<template>
    <div :class="['parametric', {
        'is-ready': isReady,
        'is-overlay': isFilterOpen
    }]">
        <Results />
        <GenplanPopup ref="genplanModal" @sendBuilding="buildingSelect"></GenplanPopup>
        <Filters :isFilterOpen="isFilterOpen"
                 ref="filter"
                 v-on:close="isFilterOpen = false"
                 @openModal="openGenplan"/>
        <OpenFilter @click.native="isFilterOpen = true"/>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Filters from './Filters/Filters.vue';
import GenplanPopup from './Genplan-popup/GenplanPopup.vue';
import OpenFilter from './OpenFilter/OpenFilter.vue';
import Results from './Results/Results.vue';

export default {
    data: () => {
        return {isFilterOpen: false};
    },

    components: {
        Filters,
        GenplanPopup,
        Results,
        OpenFilter
    },

    computed: {...mapGetters({isReady: 'GET_IS_READY'})},

    methods: {...mapActions(['initApp']),
        openGenplan() {
            this.$refs.genplanModal.openModal();
        },
        buildingSelect() {
            this.$refs.filter.change();
        }
    },

    mounted() {
        const body = {type: 'init'};

        this.initApp(body);
    }

};
</script>
<style>
    .my-callback {
        height: 100vh;
        max-height: 100vh;
    }


</style>
